import { Translation } from "src/app/state-management/calculation-state";
import { FontWeight } from "../pdf-export-service.settings";
import { Margin } from "./pdf-export.types";

export const CellSide = {
    none: 0,
    left: 1,
    top: 1 << 1,
    right: 1 << 2,
    bottom: 1 << 3,
    all: 0b1111,
    horizontal: 0b1010,
    vertical: 0b0101,
} as const;

export type CellSide = typeof CellSide[keyof typeof CellSide];

export const FontStyle = {
    ITALIC: 1 << 3,
    UNDERLINED: 1 << 4
} as const;

export type FontStyle = typeof FontStyle[keyof typeof FontStyle];

export enum Branding {
    TO_BUILD = 'TO_BUILD',
    TO_BUILD_PROJECTS = 'TO_BUILD_PROJECTS',
    PGA = 'PGA'
}

export interface TextStyle {
    fontSize: number;
    color?: number;
    weight?: FontWeight;
    boldWeight?: FontWeight;
    isItalic?: boolean;
    isUnderlined?: boolean;
}

export interface CellFormat {
    horizontalTextAlignment?: 'left' | 'center' | 'right';
    backgroundColor?: number;
    textStyle?: TextStyle;
    lineSpacing?: number;
    margin?: Margin;
    border?: {
        thickness?: number;
        color?: number;
        sides?: number;
        opacity?: number;
    }
}

export interface CellData {
    dataType?: 'variable' | 'fixed',
    // variablePath?: string;
    fixedValue?: Translation;
    colType?: 'currency' | 'text' | 'html' | 'number' | 'integer' | 'percentage';
}